import $ from "jquery";

/* global tinyMCE */

$(document).on("turbolinks:load", function() {
  // "texttooltip" is the name of the plugin referenced in tinymce.yml
  if (!window.tinyMCEPluginList) {
    window.tinyMCEPluginList = [];
  }

  window.tinyMCEPluginList.push([
    "texttooltip",
    function(editor) {

        /* DIALOG WINDOWS */
      // Insert a new tooltip
      var insertDialog = function () {
        const currentSelection = tinyMCE.activeEditor.selection.getContent();
        return editor.windowManager.open({
          title: "Insert some text with a tooltip",
          body: [
            {
              type: "textbox",
              name: "text_string",
              label: "Enter the text to show",
              value: currentSelection, // populate field if user selects some text
            },
            {
              type: "textbox",
              name: "tooltip_string",
              label: "Enter the tooltip text",
            }
          ],
          buttons: [
            {
              text: "Cancel",
              onclick: "close"
            },
            {
              text: "Insert",
              onclick: "submit"
            }
          ],
          onsubmit: function (api) {
            const randomId = Math.floor(Math.random() * 1000);
            const tooltip = api.data.tooltip_string;
            const text = api.data.text_string;
            editor.insertContent(`
              <span id="tooltip-${randomId}" class="card-tooltip" title="${tooltip}">${text}</span>
            `);
          }
        });
      };

      // Edit an existing tooltip
      var editDialog = function () {
        const el = tinyMCE.activeEditor.selection.getNode();
        return editor.windowManager.open({
          title: "Edit this tooltip",
          body: [
            {
              type: "textbox",
              name: "text_string",
              label: "Enter the text to show",
              value: el.textContent
            },
            {
              type: "textbox",
              name: "tooltip_string",
              label: "Enter the tooltip text",
              value: el.title
            }
          ],
          buttons: [
            {
              text: "Cancel",
              onclick: "close"
            },
            {
              text: "Insert",
              onclick: "submit"
            }
          ],
          onsubmit: function (api) {
            const tooltip = api.data.tooltip_string;
            const text = api.data.text_string;
            el.title = tooltip;
            el.textContent = text;
            editor.windowManager.close();
          }
        });
      };

      /* HELPER FUNCTIONS */

      // Remove a tooltip completely
      function deleteTooltip() {
        const el = tinyMCE.activeEditor.selection.getNode();
        el.remove();
      }

      // Highlight the button when we are in an inserted tooltip
      function monitorNodeChange() {
        const btn = this;
        editor.on("NodeChange", function(e) {
          btn.disabled(
            e.element.classList.contains("card-tooltip") ||
            e.element.parentElement.classList.contains("card-tooltip")
          );
        });
      }

      /* REGISTER BUTTONS */

      // Add a toolbar button that opens the dialog
      editor.addButton("texttooltip", {
        text: "Insert text w/ tooltip",
        icon: "help",
        tooltip: "Open a modal and enter the text / tooltip you want to insert",
        onclick: insertDialog,
        onpostrender: monitorNodeChange
      });

      // Add an item to the insert menu that opens the dialog
      editor.addMenuItem("texttooltip", {
        text: "Insert text with tooltip",
        icon: "help",
        context: "insert", // this is the name of the dropdown menu in which it will be placed
        onclick: insertDialog,
      });

      // Add an edit button to show in the context toolbar
      editor.addButton("edittexttooltip", {
        text: "Edit",
        icon: "help",
        onclick: editDialog
      });

      // Add a delete button to show in the context toolbar
      editor.addButton("deletetexttooltip", {
        text: "Delete",
        icon: "remove",
        onclick: deleteTooltip
      });

      /* CONTEXT TOOLBAR */

      // add a context menu when we click inside a tooltip
      editor.addContextToolbar("span.card-tooltip", "edittexttooltip  deletetexttooltip");
    },
  ]);
});
